import { headers, logPrefix, PROFILE_STORAGE_KEY_EXPIRED_TIME } from './constants';
import JSONResponseHandler from '../serviceHelpers/JSONResponseHandler';
import { APIErrorResponse, isAPIErrorResponse } from '../serviceHelpers/APIErrorResponse';
import Identity from './identity';

/**
 * Removes a oidc identity from the user's identity.
 *
 * @param identifier
 *
 * @returns
 */

export default async function unlinkOIDC(identifier: string): Promise<APIErrorResponse | string> {
  const isLoggedIn = await Identity.isLoggedIn();
  if (!isLoggedIn) {
    throw new Error(`${logPrefix} Missing or invalid jwt`);
  }

  return fetch(`${Identity.apiOrigin}/identity/public/v2/oidc/unlink`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${Identity.userIdentity.accessToken}`,
      ...headers
    },
    body: JSON.stringify({ identifier })
  })
    .then(JSONResponseHandler)
    .then(json => {
      if (isAPIErrorResponse(json)) {
        throw json;
      } else {
        localStorage.removeItem(PROFILE_STORAGE_KEY_EXPIRED_TIME);

        return json;
      }
    });
}
